import { useToggleState } from '@cian/react-utils';
import { useDeviceType } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { Cat } from 'shared/components/Cat';
import { caCatClick, caPlaceAnAd } from 'shared/components/tracking';
import { selectDealType } from 'shared/selectors/dealType';
import { selectOfferType } from 'shared/selectors/offerType';
import { prepareCategoryCa } from 'shared/utils/prepareCategoryCa';
import { useSound } from 'use-sound';
import { useTimeout } from 'usehooks-ts';

export const CatContainer: React.FC = () => {
  const { state: catVisible, toggle: toggleCatVisible } = useToggleState(false);

  const { state: modalVisible, toggle: toggleModalVisible } = useToggleState(false);

  const offerType = useSelector(selectOfferType);

  const dealType = useSelector(selectDealType);

  const caCategory = prepareCategoryCa(dealType, offerType);

  const device = useDeviceType();

  const [play, { stop }] = useSound('https://static.cdn-cian.ru/frontend/info-assets/sob-guide/sounds/cat.wav');

  const handleClickCat = () => {
    caCatClick(caCategory);

    toggleModalVisible();

    play();

    navigator.vibrate([6900]);
  };

  const handleCloseModal = () => {
    toggleModalVisible();
    stop();
  };

  const handleClickPlaceAnAd = () => {
    caPlaceAnAd(caCategory, 'cat');
  };

  useTimeout(() => toggleCatVisible(), 4000);

  return (
    <Cat
      device={device}
      modalVisible={modalVisible}
      catVisible={catVisible}
      onModalClose={handleCloseModal}
      onCatClick={handleClickCat}
      onClickPlaceAnAd={handleClickPlaceAnAd}
    />
  );
};
